import "./Content.css";

function Content() {
  return (
    <>
      {/* =========================
          Index Status
          ========================= */}
      <main id="top" className="content-inner">
        <section className="index-status-section">
          <div className="index-status">
            <div className="index-status-item index-status-regime">
              <div className="regime-badge">
                Elevated regime
              </div>

              <div className="index-status-note">
                Baseline: 2000–2024 average = 100
              </div>
            </div>

            <div className="index-status-item">
              <div className="status-label">
                Coverage
              </div>

              <div className="status-value">
                6 national dailies
              </div>

              <div className="index-status-note">
                Read every morning
              </div>
            </div>

            <div className="index-status-item">
              <div className="status-label">
                History
              </div>

              <div className="status-value status-number">
                9,123 daily readings
              </div>

              <div className="index-status-note">
                Since January 2000
              </div>
            </div>
          </div>
        </section>


        {/* =========================
            Roles
            ========================= */}
        <section id="roles" className="roles-section">
          <h2>
            We measure what Poland has only ever argued about<span style={{ color: "#EF3A5D" }}>.</span>
          </h2>

          <div className="roles-grid">

            <div className="role-card">
              <div className="role-number">01</div>

              <div className="role-label">
                Detects
              </div>

              <h3>
                Polish uncertainty runs on a Polish clock.
              </h3>

              <p>
                Every day the index measures how much of Poland’s national press
                is about uncertain economic policy: taxes, the budget, EU funds, 
                the central bank, a change of government. It rises when policy is 
                in question, and stays flat when the news is loud but economic 
                policy is not.
              </p>

              <a
                href="product.html#detects"
                className="learn-more"
              >
                <span>Learn More</span>
              </a>
            </div>


            <div className="role-card">
              <div className="role-number">02</div>

              <div className="role-label">
                Conditions
              </div>

              <h3>
                The normal you calibrated on is gone.
              </h3>

              <p>
                Poland moved into a higher band of uncertainty in 2022 and has not 
                returned to the old one. The index shows where today’s reading sits 
                against 26 years of history, so your assumptions are set against the 
                world you’re in, not the average of two different ones.
              </p>

              <a
                href="product.html#conditions"
                className="learn-more"
              >
                <span>Learn More</span>
              </a>
            </div>


            <div className="role-card">
              <div className="role-number">03</div>

              <div className="role-label">
                Quantifies
              </div>

              <h3>
                A number you can put in a model.
              </h3>

              <p>
                In our published models, rising uncertainty is followed by a weaker zloty 
                and, over longer samples, slower credit growth. The method and the series 
                are documented in full, so your analysts can test what the index adds to 
                your own models.
              </p>

              <a
                href="product.html#quantifies"
                className="learn-more"
              >
                <span>Learn More</span>
              </a>
            </div>

          </div>
        </section>


        {/* =========================
            Validation
            ========================= */}
        <section className="validation-section">

          <div className="validation-intro">
            <div>
              <h2>
                An index that moves with every headline is measuring the wrong
                thing<span style={{ color: "#EF3A5D" }}>.</span>
              </h2>
            </div>

            <p>
              We tested the index against twenty-six years of Polish history: months
              that should move it, and months that shouldn’t. Here is what happened.
            </p>
          </div>


          <div className="validation-grid">

            {/* Moved */}
            <div className="validation-card validation-moved">
              <div className="validation-label">
                Moved
              </div>

              <div className="validation-list">

                <div className="validation-event">
                  <div>Brexit referendum</div>
                  <span>June 2016</span>
                </div>

                <div className="validation-event">
                  <div>COVID-19 lockdown</div>
                  <span>March 2020</span>
                </div>

                <div className="validation-event">
                  <div>Energy and inflation shock</div>
                  <span>September 2022</span>
                </div>

                <div className="validation-event">
                  <div>Change of government</div>
                  <span>December 2023</span>
                </div>

              </div>
            </div>


            {/* Didn't move */}
            <div className="validation-card validation-static">

              <div className="validation-label">
                Didn't move
              </div>

              <div className="validation-list">

                <div className="validation-event">
                  <div>EU accession</div>
                  <span>May 2004</span>
                </div>

                <div className="validation-event">
                  <div>Smolensk air disaster</div>
                  <span>April 2010</span>
                </div>

                <div className="validation-event">
                  <div>Rule-of-law dispute</div>
                  <span>July 2017</span>
                </div>

              </div>

              <p className="validation-conclusion">
                Three of the most covered events since 2000 left the index
                where it was. Each mattered. None of them left economic policy
                in doubt.
              </p>

            </div>

          </div>
        </section>
      </main>
    </>
  );
}

export default Content;